module.exports = __webpack_public_path__ + "static/media/banner_cremacion_2.bc17cc5d.jpg";